/* ============
 * Vuex Actions
 * ============
 *
 * All the actions that can be used
 * inside the store
 */

import * as types from './mutation-types';
import Vue from 'vue';

// Account
export const getAccount = ({ commit }) => {
  return Vue.$http.get('/account').then((response) => {
    commit(types.GET_ACCOUNT, response.data.user);
  });
};

export const setAccount = ({ commit }, account) => {
  // commit(types.SET_ACCOUNT, account);
};

export const updateAccount = ({ commit }, account) => {
  commit(types.UPDATE_ACCOUNT, account);
};

export const updateIsSyncProgress = ({ commit }, data) => {
  commit(types.UPDATE_IS_SYNC_PROGRESS, data);
};

export const changePlan = ({ commit }, plan) => {
  commit(types.CHANGE_PLAN, plan);
};

export const resetAccount = ({ commit }) => {
  commit(types.RESET_ACCOUNT);
};

// Auth
export const login = ({ commit }, data) => {
  commit(types.LOGIN, data);
};

export const logout = ({ commit }) => {
  commit(types.LOGOUT);
};

export const checkAuthentication = ({ commit }) => {
  commit(types.CHECK_AUTHENTICATION);
};

// Users
export function getUsers ({ commit }) {
  return Vue.$http.get('/sub-users').then((response) => commit(types.GET_USERS, response.data.user));
}

// Booking
export const getBooking = ({ commit }) => {
  return Vue.$http.get('/bookings').then((response) => {
        commit(types.GET_BOOKING, response.data.bookings);
});
};

// Billing
// export const getBilling = ({ commit }, data) => {
//     commit(types.GET_BILLING, data);
// };

export const updateBilling = ({ commit }, data) => {
  commit(types.UPDATE_BILLING, data);
};

export const changeLang = ({ commit }, data) => {
    commit(types.CHANGE_LANG, data);
};



// WEBPACK FOOTER //
// ./src/app/store/actions.js